import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const FaqPageSession = React.lazy(() => import('../faq/FaqPageSession'));
const FaqPageHeader = React.lazy(() => import('../faq/FaqPageHeader'));

function FaqPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <FaqPageHeader />
       <FaqPageSession />
      </Suspense>
    </div>
  );
}

export default FaqPage;
